import {
  AbstractControl,
  ValidatorFn,
  FormControl,
  FormGroup
} from '@angular/forms';

export class CustomValidators {
  constructor() {}
  static requiredArray(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (Array.isArray(control.value) && control.value.length > 0) {
        return null;
      }
      return { required: true };
    };
  }
  static onlyChar(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == '') return null;

      let re = new RegExp('^[a-zA-Z ]*$');
      if (re.test(control.value)) {
        return null;
      } else {
        return { onlyChar: true };
      }
    };
  }
  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }
  static onlyNumber(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == '') return null;

      let re = new RegExp('^[0-9]*$');
      if (re.test(control.value)) {
        return null;
      } else {
        return { onlyNumber: true };
      }
    };
  }
  static requiredLeastOne(fields:Array<string>) {
    return (formGroup: FormGroup) => {
      let leastOneComplete = false;
      for (let field of fields) {
        if(formGroup.controls[field].value){
          leastOneComplete = true
          break;
        }
      }
      if(!leastOneComplete){
        for (let field of fields) {
          formGroup.controls[field].setErrors({ requiredLeastOne: true });
        }
      }else{
        for (let field of fields) {
          formGroup.controls[field].setErrors(null);
        }
      }

      return null;
    };
  }

  static requiredLeastOneV2(conditional:string, conditionalValue:any ,fields:Array<string>) {
    return (formGroup: FormGroup) => {
      if(formGroup.controls[conditional].value!=conditionalValue){
        for (let field of fields) {
          formGroup.controls[field].setErrors(null);
        }
        return null;
      }
      let leastOneComplete = false;
      for (let field of fields) {
        if(formGroup.controls[field].value){
          leastOneComplete = true
          break;
        }
      }
      if(!leastOneComplete){
        for (let field of fields) {
          formGroup.controls[field].setErrors({ requiredLeastOne: true });
        }
      }else{
        for (let field of fields) {
          formGroup.controls[field].setErrors(null);
        }
      }

      return null;
    };
  }
  static requiredAllFields(conditional: string, conditionalValue: any[], fields: string[]) {
    return (formGroup: FormGroup) => {
      const conditionalFieldValue = formGroup.controls[conditional].value;
  
      if (!conditionalValue.includes(conditionalFieldValue)) {
        for (let field of fields) {
          formGroup.controls[field].setErrors(null);
        }
        return null;
      }
  
      let allComplete = true;
      for (let field of fields) {
        if (!formGroup.controls[field].value) {
          allComplete = false;
          break;
        }
      }
  
      if (!allComplete) {
        for (let field of fields) {
          formGroup.controls[field].setErrors({ requiredAllFields: true });
        }
      } else {
        for (let field of fields) {
          formGroup.controls[field].setErrors(null);
        }
      }
  
      return null;
    };
  }
  
  static requiredIfConditionAndComponent(
    componentRef: () => any,
    conditionalField: string,
    conditionalValue: any
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fieldValue = control.get(conditionalField)?.value;
      // Si se cumple la condición, verificamos el valor del componente
      if (fieldValue === conditionalValue) {
        const component = componentRef(); // Referencia al componente
        const selectedItem = component?.modelSelectedId;
        // Si el componente no tiene valor, devolvemos un error
        if (!selectedItem) {
          return { requiredIfConditionAndComponent: true };
        }
      }

      return null;
    };
  }

  static requiredIfisShow(sw_field:string, field: string) {
    return (formGroup: FormGroup) => {
      if(formGroup.controls[sw_field].value){
        if(!formGroup.controls[field].value){
          formGroup.controls[field].setErrors({requiredIfIsShow: true})
        }else {
          formGroup.controls[field].setErrors(null)
        }
      }else{
        formGroup.controls[field].setErrors(null)
      }
    }
  }

  static requiredIfisShowV2(sw_field:string, conditionalValue:any, field: string) {
    return (formGroup: FormGroup) => {
      if(formGroup.controls[sw_field].value==conditionalValue){
        if(!formGroup.controls[field].value){
          formGroup.controls[field].setErrors({requiredIfIsShow: true})
        }else {
          formGroup.controls[field].setErrors(null)
        }
      }else{
        formGroup.controls[field].setErrors(null)
      }
    }
  }

  static requiredWithCondicionals(sw_field: string, conditionalValues: any[], field: string) {
    return (formGroup: FormGroup) => {
      const swFieldValue = formGroup.controls[sw_field].value;
  
      if (conditionalValues.includes(swFieldValue)) {
        if (!formGroup.controls[field].value) {
          formGroup.controls[field].setErrors({ requiredIfIsShow: true });
        } else {
          formGroup.controls[field].setErrors(null);
        }
      } else {
        formGroup.controls[field].setErrors(null);
      }
    };
  }
}


